export default __webpack_public_path__ + "static/media/credits.f60a5805.svg";